import { CommonModule } from '@angular/common'
import { AfterViewInit, Component, inject, ViewChild } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { MatIconModule } from '@angular/material/icon'
import { ButtonModule } from '../../button/button.module'
import { MatButtonModule } from '@angular/material/button'
import { GlobalDataService } from 'src/app/core/services/global-data.service'
import { GalleryComponent, GalleryItem, GalleryModule, ImageItem } from 'ng-gallery'
import { IGalleryDialogOptions } from 'src/app/core/interfaces/modal.interface'
import { IconButtonIconSize, IconButtonThemeSize, IconButtonThemeType } from '../../icon-button/icon-button.component'
import { IconButtonModule } from '../../icon-button/icon-button.module'


declare global {
  interface Window {
    gtag: any
  }
}

@Component({
  selector: 'gallery-dialog-component',
  template: `
    @if (data.title) {
      <div mat-dialog-title class="title">
        <span data-testid="title">{{data.title}}</span>
        <div class="close">
          <app-icon-button
            [matIcon]="'close'"
            aria-label="Close dialog"
            i18n-aria-label="@@asset-details.close-button.aria-label"
            [themeSize]="IconButtonThemeSize.Medium"
            [themeType]="IconButtonThemeType.Unstyled"
            [iconSize]="IconButtonIconSize.Large"
            (click)="dialogRef.close()"
          ></app-icon-button>
        </div>
      </div>
    }
    <div mat-dialog-content class="content" data-testid="gallery-dialog">
      <gallery #gallery class="gallery" imageSize="contain" [counter]="false" [autoHeight]="false" [nav]="false" [loop]="true">
        <ng-container *galleryThumbDef="let item; let active = active">
          <span class="thumb" [class.active]="active">
          </span>
        </ng-container>
      </gallery>
      <div class="nav nav-left">
        <app-icon-button
          [matIcon]="'chevron_left'"
          aria-label="Previous"
          [themeSize]="IconButtonThemeSize.Medium"
          [iconSize]="IconButtonIconSize.Large"
          (click)="galleryRef.prev()"
        ></app-icon-button>
      </div>
      <div class="nav nav-right">
        <app-icon-button
          [matIcon]="'chevron_right'"
          aria-label="Next"
          [themeSize]="IconButtonThemeSize.Medium"
          [iconSize]="IconButtonIconSize.Large"
          (click)="galleryRef.next()"
        ></app-icon-button>
      </div>
    </div>
  `,
  styles: [`
    @use "sass:map";
    @import "src/assets/_colors";
    @import "src/assets/zindex";
    @import 'src/assets/mixins';

    .title {
      display: inline-block;
      width: 100%;
      border-bottom: unset;
    }

    .close {
      position: absolute;
      top: 10px;
      right: 32px;

      @include mq(small) {
        right: 0;
      }
    }

    .content {
      display: block;
      position: relative;
      padding-top: 0 !important;
    }

    .gallery {
      padding: 0 10%;
      width: auto;
      height: calc(100% - 32px);
      max-height: 700px;
      background-color: white;
    }

    .thumb {
      width: 100%;
      height: 100%;

      &.active {
        border: 4px solid map-get($light, primary, main);
      }
    }

    .nav {
      position: absolute;
      bottom: 50px;
      z-index: 1;

      &-left{
        left: 32px;

        @include mq(small) {
          left: 0;
        }
      }

      &-right{
        right: 32px;

        @include mq(small) {
          right: 0;
        }
      }
    }

    ::ng-deep gallery-thumb gallery-image {
      opacity: 1 !important;
    }

    ::ng-deep gallery-thumbs {
      padding-top: 20px;
    }

    ::ng-deep gallery-core {
      overflow: visible !important;
    }

    ::ng-deep .g-box {
      width: 125% !important;
      margin: 0 -12.5% 0 -12.5%;
    }

  `],
  imports: [
    CommonModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    GalleryModule,
    ButtonModule,
    IconButtonModule,
  ]
})
export class GalleryDialogComponent implements AfterViewInit {
  data = inject<IGalleryDialogOptions>(MAT_DIALOG_DATA)
  dialogRef = inject<MatDialogRef<GalleryDialogComponent>>(MatDialogRef)
  protected globalDataService = inject(GlobalDataService)

  window = inject(Window)
  @ViewChild('gallery') galleryRef!: GalleryComponent
  IconButtonThemeSize = IconButtonThemeSize
  IconButtonIconSize = IconButtonIconSize
  IconButtonThemeType = IconButtonThemeType

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.galleryRef.load(this.galleryImages())
    }, 1000)
  }

  galleryImages(): Array<GalleryItem> {
    return this.data.images.map(({ src, thumb }: { src: string, thumb: string }) => new ImageItem({ src,thumb }))
  }
}
